module.exports = __webpack_public_path__ + "static/outsourcing-b93e1fdbabe8b48daa7df7c093891f6b.jpg";